import type { PostCategoryId as CmsPostCategoryId, PostIds as CmsPostIds } from "./types";
import { postCategorySchema as cmsPostCategorySchema, postIdsSchema as cmsPostIdsSchema } from "./types";
import {
  buildPostIds,
  getPost as getCmsPost,
  getPostByIdAndCategory as getCmsPostByIdAndCategory,
  getPostBySlug as getCmsPostBySlug,
  getPostId as getCmsPostId,
  getPostsByCategory as getCmsPostsByCategory,
} from "./utils";

import ArchetypeContent from "./ArchetypeContent";
import useArchetypes from "./hooks/useArchetypes";
import useCmsPosts from "./hooks/useCmsPosts";

export {
  ArchetypeContent,
  buildPostIds,
  cmsPostCategorySchema,
  cmsPostIdsSchema,
  getCmsPost,
  getCmsPostByIdAndCategory,
  getCmsPostBySlug,
  getCmsPostId,
  getCmsPostsByCategory,
  useArchetypes,
  useCmsPosts,
};
export type { CmsPostCategoryId, CmsPostIds };
